import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';

const HEAD_SCRIPT_INNER_HTML = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','GTM-M3Q4JHN');`;

export const GoogleTagManager = () => {
  useEffect(() => {
    const noscriptEl = document.createElement('noscript');
    const iframeEl = document.createElement('iframe');
    iframeEl.src = 'https://www.googletagmanager.com/ns.html?id=GTM-M3Q4JHN';
    iframeEl.height = '0';
    iframeEl.width = '0';
    iframeEl.setAttribute('style', 'display:none;visibility:hidden');

    noscriptEl.append(iframeEl);
    document.body.prepend(noscriptEl);
  }, []);
  return (
    <Helmet>
      <script type="text/javascript">{HEAD_SCRIPT_INNER_HTML}</script>
    </Helmet>
  );
};
